import firebaseConfig from "../config/firebase"
import firebase from "firebase/app"
import "firebase/firestore"
import 'firebase/storage'
import 'firebase/auth'

import Vue from "vue"

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db = firebaseApp.firestore()
const storageRef = firebase.storage().ref()
const googleProvider = new firebase.auth.GoogleAuthProvider()

Vue.prototype.db = db
Vue.prototype.storageRef = storageRef

export { firebase, googleProvider }